<div class="tooltip" [class]="position">
  <div class="content-wrapper">
    <img *ngIf="isWarning; else questionMark" src="./assets/img/warning.png" width="20" height="20" />
    <ng-template #questionMark>
      <span>?</span>
    </ng-template>
    <div class="content" [ngClass]="contentClass" [innerHTML]="tooltipContent" routeTransformer></div>
  </div>
</div>
